<router-outlet></router-outlet>
<sbd-doug-frontend-main-drawer id="main-drawer"></sbd-doug-frontend-main-drawer>
